var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "spinner spinner--rotate-diamond", style: _vm.styles },
    [
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle }),
      _vm._v(" "),
      _c("div", { staticClass: "diamond", style: _vm.diamondStyle })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e1581b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52e1581b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Diamond.vue
// module id = kwRS
// module chunks = 0